module.exports = __webpack_public_path__ + "img/zhuangxinag.3803db97.png";